import Service from '@ember/service';

import { service } from '@ember/service';

import { elementFilter } from 'rise-ui/utils/dom.js';
import { split } from 'rise-ui/utils/string.js';

export default class DocumentEvents extends Service {
  @service ssr;

  onDocumentEvent(event, handler) {
    return e => {
      const el = e.target;
      let { when, is, isNot, then } = handler;
      if (typeof when === 'function') {
        when = when(e, event, handler);
      }
      if (!when || !elementFilter(el, is, isNot)) {
        return;
      }
      if (typeof then === 'function') {
        then(e, event, handler);
      }
    };
  }

  getHandlerEvents(events) {
    return split(events, [',', ' ']);
  }

  /**
   * @typedef {string|HTMLElement} SelectorOrElement
   */
  /**
   * @typedef {SelectorOrElement|SelectorOrElement[]} SelectorsOrElements
   */
  /**
   * Add handler for when an event occurs within the document
   * @param {string|string[]} events Name(s) of event to observe
   * @param {{ when(): (boolean|void), is?: SelectorsOrElements, isNot?: SelectorsOrElements, then(): (*|void) }} handler
   * @return {function(): void} off Function to remove event handler
   */
  on(events, handler) {
    if (this.ssr.isSsr) {
      return () => {};
    }
    const eventOffs = [];
    const off = () => eventOffs.forEach(eo => eo());
    this.getHandlerEvents(events).forEach(event => {
      const onDocumentEvent = this.onDocumentEvent(event, handler);
      const options = { capture: true };
      document.addEventListener(event, onDocumentEvent, options);
      eventOffs.push(() => document.removeEventListener(event, onDocumentEvent, options));
    });
    return off;
  }

  off(off) {
    if (typeof off === 'function') {
      off();
    }
  }
}
